import { CartControl } from '@/components/CartControl/CartControl';
import { useAppSelector } from '@/hooks/useAppSelector';
import { useResizeListingItems } from '@/hooks/useResizeListingItems';
import { Listing, ListingList } from '@showclix-shared/ListingComponents';
import { FunctionComponent, useEffect, useState } from 'react';
import { useAppData } from '@/contexts/AppData';
import { BaseLayout } from '@/layouts/base';
import { isAllEventsLoadedSelector } from '@/store/selectors/events';
import { Membership } from '@/components/Membership';
import { useLocation, Outlet } from 'react-router-dom';
import { PATH_HOME } from '../constants/pathConstatnts';
import {
  isLoggedInSelector,
  hasMembershipSelector,
} from '../store/selectors/membership';

export interface HomeViewProps {
  listings: Listing[];
}

export const HomeView: FunctionComponent<HomeViewProps> = ({ listings }) => {
  const { uiConfig, membershipConfig, listingId } = useAppData();
  const [showListings, setShowListings] = useState<boolean>(
    !membershipConfig.hasOwnProperty('membershipType'), // eslint-disable-line
  );
  const location = useLocation();

  const isAllEventsLoaded = useAppSelector(isAllEventsLoadedSelector);
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const hasMembership = useAppSelector(hasMembershipSelector);

  useEffect(() => {
    if (!hasMembership || isLoggedIn) {
      listings.forEach((listing) => {
        (window as any)['Checkout_' + listing.slugHash + '_loaded'] = false;
      });
    }
    setShowListings(!hasMembership || isLoggedIn);
  }, [isLoggedIn, hasMembership]);

  useResizeListingItems();

  return (
    <BaseLayout
      config={{
        bannerImage: uiConfig.images.header_banner,
        profileImage: uiConfig.images.profile_image,
        title: uiConfig.listings.title,
        content: uiConfig.listings.content,
      }}
      headerContent={<CartControl />}
    >
      {location.pathname === PATH_HOME && showListings && (
        <ListingList listings={listings} loading={!isAllEventsLoaded} />
      )}
      <Outlet />
      {location.pathname === PATH_HOME && (
        <Membership
          {...membershipConfig}
          listingId={listingId}
          isAllEventsLoaded={isAllEventsLoaded}
        />
      )}
    </BaseLayout>
  );
};
